import React from "react";
import { CardCvcElement, CardElement, CardExpiryElement, CardNumberElement } from "@stripe/react-stripe-js";
import { CommonLabel, FormFlexWrapper } from "@app/components/commonStyles";

const CARD_ELEMENT_OPTIONS = {
    hidePostalCode: true,
    style: {
        base: {
            color: "#33403e",
            fontSize: "14px",
            fontFamily: "sans-serif",
            fontSmoothing: "antialiased",
            "::placeholder": {
                color: "rgb(117,117,117)"
            }
        },
        invalid: {
            color: "#33403e",
            ":focus": {
                color: "#33403e"
            }
        }
    }
};

function CardSection({ onChange }: any) {
    return (
        <>
            {/* <FormFlexWrapper className="mb-0">
                <div className="only-child">
                    <CommonLabel className="label-color">
                        Card Number
                    </CommonLabel>
                    <CardNumberElement
                        options={{ showIcon: true }}
                        onChange={onChange}
                    />
                </div>
            </FormFlexWrapper>
            <FormFlexWrapper className="two-child-layout mb-0">
                <div className="child">
                    <CommonLabel className="label-color">
                        Expiration date
                    </CommonLabel>
                    <CardExpiryElement
                        onChange={onChange}
                    />
                </div>
                <div className="child">
                    <CommonLabel className="label-color">
                        CVC
                    </CommonLabel>
                    <CardCvcElement
                        onChange={onChange}
                    />
                </div>
            </FormFlexWrapper> */}
            <CardElement options={CARD_ELEMENT_OPTIONS} onChange={onChange} />
        </>
    );
}

export default CardSection;